import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import Auth from "./pages/auth";
import ProtectedRoute from "./components/protected-route";
import OrgHome from "./pages/org";
import WelcomeScreen from "./pages/welcome.js";
import InvitationHome from "./pages/invitation/index.js";
import LifeTimeInvitationHome from "./pages/life_time_membership_invite/index.js";
import AdminHome from "./pages/admin";
import UserHome from "./pages/user";
import GroupHome from "./pages/group";

function Routes(props) {
  return (
    <BrowserRouter>
      <Route exact path={"/"} component={Auth} />
      <Route path={"/login"} component={Auth} />
      <Route path={"/signup"} component={Auth} />
      <ProtectedRoute path="/welcome" component={WelcomeScreen} />
      <ProtectedRoute path="/process-invite" component={InvitationHome} />
      <ProtectedRoute path="/process-life-time-membership-invite" component={LifeTimeInvitationHome} />
      <ProtectedRoute path="/admin" component={AdminHome} />
      <ProtectedRoute path="/org" component={OrgHome} />
      <ProtectedRoute path="/group" component={GroupHome} />
      <ProtectedRoute path="/user" component={UserHome} />
    </BrowserRouter>
  );
}

export default Routes;
